import React, { lazy, useEffect, useContext } from 'react';
import Suspense from '../../element/Suspense';
import { SubmenuContext } from '../../element/Menu/submenuContext';
import SubMenuItems from '../../element/Menu/SubMenuItems';

const ApprovalPerformanceView = lazy(() => import('./view'));

const ApprovalPerformance = (): React.ReactElement => {
  const { setSubmenu } = useContext(SubmenuContext);
  useEffect(() => {
    if (setSubmenu) {
      setSubmenu(SubMenuItems.approvalPerformance.key);
    }
  }, [setSubmenu]);

  return (
    <Suspense>
      <ApprovalPerformanceView />
    </Suspense>
  );
};

export default ApprovalPerformance;
